<h1 class="title is-2 has-text-weight-light">Bienvenue dans NEO RHEA</h1>
<p class="is-size-5">Utilisez le menu latéral pour explorer les données.</p>
